;(function module() {
  angular.module('app.ui.form.ctrls').controller('ClonePositionController', [
    '$uibModalInstance',
    'cloningData',
    'usSpinnerService',
    'logger',
    '$timeout',
    'PositionApi',
    'practiceAreaService',
    'locationsGenericService',
    '$window',
    function controller(
      $uibModalInstance,
      cloningData,
      usSpinnerService,
      logger,
      $timeout,
      PositionApi,
      practiceAreaService,
      locationsGenericService,
      $window
    ) {
      let vm = this
      console.debug('cloningData', cloningData)

      vm.positions = angular.copy(cloningData.positions)
      vm.allContractType = angular.copy(cloningData.allContractType)
      vm.allOccupations = angular.copy(cloningData.allOccupations)
      vm.allPracticeArea = angular.copy(cloningData.allPracticeArea)
      vm.allLocations = angular.copy(cloningData.allLocations)

      vm.positions = vm.positions.map(position => {
        return initializeClonePosition(position)
      })

      vm.currentIndex = 0
      vm.pqeOptions = {
        round: 1,
        from: -2,
        to: 11,
        step: 0.5,
        dimension: '+ years',
        scale: [-2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, '11+'],
      }

      const clonePositionSuccessHandler = clone => {
        $timeout(() => {
          logger.notify(
            'success',
            `Successfully cloned '${vm.positions.length}' ${
              vm.positions.length === 1 ? 'position' : 'position(s)'
            }`
          )
          usSpinnerService.stop('spinner-clone-jobs')
          return $uibModalInstance.close(clone.data)
        }, 3000)

        $timeout(() => {
          $window.location.reload()
        }, 4000)
      }

      const clonePositionErrorHandler = errorResponse => {
        logger.notify(
          'error',
          `Error Cloning Jobs.
          Error Reason: ${errorResponse.statusText}
          `
        )
        usSpinnerService.stop('spinner-clone-jobs')
      }

      vm.pqeChange = () => {
        var separator
        const currentPosition = vm.positions[vm.currentIndex]
        separator = currentPosition.pqe.search(';')
        if (separator === 1) {
          currentPosition.minPQE = Number(currentPosition.pqe.slice(0, 1))
          currentPosition.maxPQE = Number(currentPosition.pqe.slice(2, 5))
        } else if (separator === 2) {
          currentPosition.minPQE = Number(currentPosition.pqe.slice(0, 2))
          currentPosition.maxPQE = Number(currentPosition.pqe.slice(3, 5))
        }
      }

      vm.nextPage = () => {
        if (vm.currentIndex < vm.positions.length - 1) {
          vm.currentIndex += 1
        }

        populateCloneLocationsAndPractices(vm.currentIndex)
      }

      vm.lastPage = () => {
        vm.currentIndex = vm.positions.length - 1
        populateCloneLocationsAndPractices(vm.currentIndex)
      }

      vm.previousPage = () => {
        if (vm.currentIndex > 0) {
          vm.currentIndex -= 1
        }

        populateCloneLocationsAndPractices(vm.currentIndex)
      }

      vm.firstPage = () => {
        vm.currentIndex = 0
        populateCloneLocationsAndPractices(vm.currentIndex)
      }

      vm.onChangePracticeArea = (event, selectedPracticeArea) => {
        if (event) {
          event.stopPropagation()
        } else {
          vm.positions[vm.currentIndex].specialties = selectedPracticeArea
        }
      }

      const initializePracticeAreas = currentIndex => {
        practiceAreaService.initialize(
          vm.positions[currentIndex].specialties,
          vm.allPracticeArea,
          false
        )
      }

      vm.onChangeLocation = (event, selectedLocation) => {
        if (event) {
          event.stopPropagation()
        } else {
          vm.positions[vm.currentIndex].locations = selectedLocation
        }
      }

      const initializeLocations = currentIndex => {
        const regionHierarchialList = locationsGenericService.initialize(
          vm.positions[currentIndex].locations,
          vm.allLocations
        )

        regionHierarchialList.sort((a, b) => (a.name > b.name ? 1 : -1))
        vm.regionHierarchialListWithEuropeOnTop = [
          ...regionHierarchialList.filter(region => region.name === 'Europe'),
          ...regionHierarchialList.filter(region => region.name !== 'Europe'),
        ]
      }

      let populateCloneLocationsAndPractices = currentIndex => {
        initializePracticeAreas(currentIndex)
        initializeLocations(currentIndex)
      }

      populateCloneLocationsAndPractices(vm.currentIndex)

      vm.setPositionType = position => {
        if (position.positionType === 1) position.type = 'Regular'
        if (position.positionType === 2) position.type = 'Custom'
        if (position.positionType === 3) position.type = 'Connect'
        if (position.positionType === 4) position.type = 'Speculative'
        if (position.positionType === 5) position.type = 'External'
        if (position.positionType !== 1 && position.positionType !== 5)
          position.externalUrl = undefined
      }

      const validateClonePosition = payload => {
        return payload
          .map((position, index) => {
            if (
              position.expiresAt &&
              new Date(position.expiresAt) < new Date()
            ) {
              logger.notify(
                'error',
                `Expiry Date is less than today for the clone Position # ` +
                  (index + 1)
              )
              return false
            }

            if (
              position.locations === undefined ||
              position.locations.length === 0
            ) {
              logger.notify(
                'error',
                'Locations are empty for the clone Position # ' + (index + 1)
              )
              return false
            }

            if (
              position.specialties === undefined ||
              position.specialties.length === 0
            ) {
              logger.notify(
                'error',
                'Practice Areas are empty for the clone Position # ' +
                  (index + 1)
              )
              return false
            }

            return true
          })
          .every(x => x === true)
      }

      vm.clonePositions = () => {
        const payload = vm.positions.map(position => {
          vm.setPositionType(position)
          const specialties = practiceAreaService.setIsSelectedChildrenPracticeArea(
            position.specialties,
            []
          )

          return {
            title: position.title,
            description: position.description,
            expiresAt: position.expiresAt,
            locations: position.locations,
            specialties: specialties,
            visible: position.visible,
            externalUrl: position.externalUrl,
            employerId: position.employerId,
            contractTypeId: position.contractTypeId,
            occupationId: position.occupationId,
            type: position.type,
            professionId: 'law',
            skills: [],
            lawPreferences: {
              minPqe: position.minPQE,
              maxPqe: position.maxPQE,
            },
          }
        })
        if (validateClonePosition(payload)) {
          usSpinnerService.spin('spinner-clone-jobs')
          logger.notify('info', `Cloning '${vm.positions.length} position(s)'`)
          console.debug('Cloning Positions', payload)
          PositionApi.createClonePositions(payload)
            .then(data => clonePositionSuccessHandler(data))
            .catch(clonePositionErrorHandler)
        }
      }

      vm.cancel = () => {
        $uibModalInstance.dismiss('cancel')
      }
    },
  ])
})()

const initializeClonePosition = position => {
  console.debug('initializeClonePosition:', position)
  if (position.professionId === 'tech' || !position.lawPreferences) {
    position.lawPreferences = {
      minPqe: position.techPreferences.minExperience
        ? position.techPreferences.minExperience
        : -2,
      maxPqe: 11,
    }
  }

  position.minPQE =
    position.lawPreferences && position.lawPreferences.minPqe
      ? position.lawPreferences.minPqe
      : -2
  position.maxPQE =
    position.lawPreferences && position.lawPreferences.maxPqe
      ? position.lawPreferences.maxPqe
      : 11
  position.pqe = `${position.lawPreferences.minPqe};${position.lawPreferences.maxPqe}`
  if (position.type === 'Regular') position.positionType = 1
  if (position.type === 'Custom') position.positionType = 2
  if (position.type === 'Connect') position.positionType = 3
  if (position.type === 'Speculative') position.positionType = 4
  if (position.type === 'External') position.positionType = 5
  // Position.visible = position.visible === 'Visible'
  if (position.specialties.length > 0)
    position.specialties = position.specialties.map(specialty => {
      specialty.isSelected = true
      return specialty
    })
  if (position.locations.length > 0)
    position.locations = position.locations.map(location => {
      location.isSelected = true
      return location
    })
  return position
}



// WEBPACK FOOTER //
// ./scripts/shared/directives/clone-position/clone-position.ctrl.js